<template>
	<!-- eslint-disable vue/no-v-html -->
	<div
		class="wrap-break-word"
		:class="{
			prose: !noProse,
		}"
	>
		<storyblok-rich-text
			v-if="richTextDocument"
			:document="richTextDocument"
			:components="richTextComponents"
		/>

		<div v-else v-html="stringContent" />
	</div>
</template>

<script setup lang="ts">
/*
 * Storyblok's own renderer handles the whole rich text structure. We only override the node types
 * where we need something it can't give us — see the components below for the reasoning behind each.
 *
 * References:
 * - https://www.storyblok.com/docs/packages/storyblok-richtext
 * - https://www.storyblok.com/docs/libraries/js/vue-sdk
 */
import type {SbRichTextDoc as ISbRichtext} from "@storyblok/js";
import {
	StoryblokRichText,
	type SbVueRichTextComponentMap,
} from "@storyblok/vue";
import RichTextBlok from "./rich-text/blok.vue";
import RichTextImage from "./rich-text/image.vue";
import RichTextLink from "./rich-text/link.vue";
import RichTextEmoji from "./rich-text/emoji.vue";

const properties = defineProps<{
	document?: ISbRichtext | string;
	noProse?: boolean;
}>();

const richTextComponents: SbVueRichTextComponentMap = {
	blok: RichTextBlok,
	image: RichTextImage,
	link: RichTextLink,
	emoji: RichTextEmoji,
};

const richTextDocument = computed<ISbRichtext | undefined>(() =>
	typeof properties.document === "object" && properties.document !== null
		? properties.document
		: undefined,
);

const stringContent = computed(() =>
	typeof properties.document === "string" ? properties.document : "",
);
</script>
